import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useLocation } from "react-router-dom";
import { SITE } from "../lib/api";

const sectionLinks = [
  { hash: "hero", label: "Accueil" },
  { hash: "prestations", label: "Prestations" },
  { hash: "disponibilites", label: "Disponibilités" },
  { hash: "galerie", label: "Galerie" },
  { hash: "contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === "/";
  const buildHref = (hash) => (onHome ? `#${hash}` : `/#${hash}`);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-strong py-3" : "py-5 bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        <a href={onHome ? "#hero" : "/"} className="flex items-center gap-3 group" data-testid="navbar-logo-link">
          <div className="w-11 h-11 rounded-full bg-white p-1 flex items-center justify-center group-hover:shadow-[0_0_22px_rgba(59,130,246,0.55)] transition-shadow">
            <img src={SITE.logo} alt="Anton Pears" className="w-full h-full object-contain rounded-full" />
          </div>
          <div className="leading-tight">
            <div className="font-display text-xl tracking-wider">ANTON PEARS</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-400">DJ · Charente 16</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {sectionLinks.map((l) => (
            <a
              key={l.hash}
              href={buildHref(l.hash)}
              data-testid={`nav-link-${l.hash}`}
              className="text-sm uppercase tracking-[0.2em] text-zinc-300 hover:text-white relative after:absolute after:left-0 after:-bottom-2 after:h-px after:w-0 after:bg-[#3B82F6] after:transition-all hover:after:w-full transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/partenaires"
            data-testid="nav-link-partenaires"
            className="text-sm uppercase tracking-[0.2em] text-zinc-300 hover:text-white relative after:absolute after:left-0 after:-bottom-2 after:h-px after:w-0 after:bg-[#3B82F6] after:transition-all hover:after:w-full transition-colors"
          >
            Partenaires
          </a>
        </nav>

        <div className="hidden lg:block">
          <a href={buildHref("contact")} className="btn-neon" data-testid="navbar-cta-button">
            Réserver une date
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
          data-testid="navbar-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden glass-strong border-t border-white/10" data-testid="navbar-mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {sectionLinks.map((l) => (
              <a
                key={l.hash}
                href={buildHref(l.hash)}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.2em] text-zinc-200 hover:text-[#3B82F6]"
                data-testid={`nav-mobile-link-${l.hash}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="/partenaires"
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-[0.2em] text-zinc-200 hover:text-[#3B82F6]"
              data-testid="nav-mobile-link-partenaires"
            >
              Partenaires
            </a>
            <a href={buildHref("contact")} onClick={() => setOpen(false)} className="btn-neon w-fit">
              Réserver une date
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
